exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sort-by-usage-tittle-card {\n  padding-top: 0em;\n  margin-top: 0em !important;\n  margin-bottom: 1.3em !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/transaction/usage/index.less
// module id = 3605
// module chunks = 0